import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';

import { NavLink } from '../NavLink/NavLink';

type Props = {
  company: {
    id: string;
  };
};

export const HomeLink = ({ company }: Props) => {
  const { t } = useTranslation('global');

  return (
    <NavLink
      href={routeFor(routes.HOMEPAGE.path, {
        company: company.id,
      })}
      iconName="house"
    >
      {t('homepage.name')}
    </NavLink>
  );
};
